import { Link } from "react-router-dom";
import { Lock, HeartHandshake, Users, ArrowRight } from "lucide-react";

const WELLS = [
  { to: "/portal/today", icon: Lock, title: "Quiet Well", tag: "Private · just you & God", body: "Journal, a voice reflection, a private prayer. Everything is saved to your Vessel.", testid: "well-quiet" },
  { to: "/portal/duo", icon: HeartHandshake, title: "Witness Well", tag: "Private · you & your Witness", body: "Video, voice, and written reflections shared with your weekly witness — seen, not judged.", testid: "well-witness" },
  { to: "/portal/community", icon: Users, title: "Community Well", tag: "Shared · your whole home", body: "A story, a breakthrough, a testimony — offered to your cohort and met with intentional encouragement.", testid: "well-community" },
];

export default function ReflectionJourney() {
  return (
    <div data-testid="portal-reflection" className="max-w-3xl">
      <p className="tracking-overline text-xs uppercase text-[#A9724E] mb-3">The Reflection Journey</p>
      <h1 className="font-serif-display font-light text-4xl md:text-5xl mb-3">Three wells to draw from.</h1>
      <p className="text-[#5E4B3C] font-body mb-10 leading-relaxed">Complete all three wells and you are <span className="italic text-[#A9724E]">fully witnessed</span> — held by God, by one, and by many.</p>
      <div className="space-y-5">
        {WELLS.map((w) => (
          <Link key={w.to} to={w.to} data-testid={w.testid} className="group block bg-white/60 border border-[#E0D8C9] rounded-xl p-6 md:p-8 hover:border-[#A9724E] transition-colors">
            <div className="flex items-start justify-between gap-4">
              <div>
                <div className="flex items-center gap-2 mb-2">
                  <w.icon className="w-4 h-4 text-[#A9724E]" strokeWidth={1.5} />
                  <p className="tracking-overline text-[10px] uppercase text-[#8a7a6a]">{w.tag}</p>
                </div>
                <h2 className="font-serif-display text-2xl text-[#2A2825] mb-2">{w.title}</h2>
                <p className="text-[#5E4B3C] font-body leading-relaxed">{w.body}</p>
              </div>
              <ArrowRight className="w-5 h-5 text-[#A9724E] mt-1 shrink-0 transition-transform group-hover:translate-x-1" strokeWidth={1.5} />
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
